import MUICollapse, { CollapseProps } from "@mui/material/Collapse";
import React, { FC } from "react";

export const Collapse: FC<CollapseProps> = (props) => (
  <MUICollapse {...props} />
);
